import React from 'react'
import { ArrowButton } from '@truphone/buttons'

function Hero(props) {
  return (
    <>
      <div className="container mx-auto py-2">
        <h1 className="text-base font-bold tracking-widest text-center uppercase mb-5 text-current">
          {props.title}
        </h1>
        {props.ctas &&
          props.ctas.map((cta, i) => {
            return (
              <div key={`hero-cta-${i}`} className="flex">
                <ArrowButton
                  className={`${
                    props.dark ? 'text-white' : 'text-blue-100'
                  } mt-6 lg:mt-10 text-lg lg:text-xl mx-auto`}
                  href={cta.href}
                >
                  {cta.text}
                </ArrowButton>
              </div>
            )
          })}
      </div>
    </>
  )
}

export default Hero
